import { sanitise } from 'sanitise-fields'
import { Modal, Popover, Tooltip } from 'bootstrap'
import { ddlClientInitialise } from 'slim-select-prefabs'
import Draggabilly from 'draggabilly'

export const popoverInitialise = () => {
    const popoverEl = document.querySelectorAll('[data-bs-toggle="popover"]')
    if (popoverEl != null) {
        const options = {
            container: 'body',
            delay: 0,
            animation: true
        }
        popoverEl.forEach((elem) => {
            new Popover(elem, options)
        })
    }
}
export const tooltipInitialise = () => {
    const tooltipEl = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    if (tooltipEl != null) {
        const options = {
            container: 'body',
            delay: 0,
            animation: true
        }
        tooltipEl.forEach((elem) => {
            new Tooltip(elem, options)
        })
    }
}
export const appendInputGroup = (name: string) => {
    const searchInputGroup = document.querySelector('.gridjs-search-input')
    const parentNode = document.querySelector('.gridjs-search')!
    const containerNode = document.querySelector('.gridjs-head')!
    if (searchInputGroup != null) {
        const divContainer = document.createElement('div') as HTMLDivElement
        divContainer.classList.add('input-group-append')
        const spanImage = document.createElement('span') as HTMLSpanElement
        spanImage.classList.add('input-group-text')
        const iSearch = document.createElement('i')
        iSearch.classList.add('fa-solid', 'fa-magnifying-glass')
        spanImage.appendChild(iSearch)
        divContainer.appendChild(spanImage)
        searchInputGroup.classList.add('inputGroupBR')
        parentNode.insertBefore(divContainer, searchInputGroup)
        const title = document.createElement('p')
        title.classList.add('float-left', 'd-inline', 'reportHeader')
        title.innerText = name
        containerNode.insertBefore(title, parentNode)
    }
}
export const createTable = (element: HTMLTableElement) => {
    const tbl = document.createElement('table') as HTMLDivElement
    tbl.id = `${element.id}Rendered`
    const row = element.parentElement as HTMLDivElement
    row.insertBefore(tbl, element)
    return tbl.id
}
export const formSubmits = () => {
    const formsCollection = document.getElementsByTagName('form')
    if (formsCollection != null) {
        for (let i = 0; i < formsCollection.length; i += 1) {
            const form = formsCollection[i] as HTMLFormElement
            form.addEventListener('submit', () => {
                sanitise()
            })
        }
    }
}
const PopulateClients = (GroupID: number, Archived: boolean) => {
    const ddlClientID = document.querySelectorAll('.ddlClientID') as NodeListOf<HTMLSelectElement>
    if (ddlClientID != null) {
        ddlClientID.forEach((element: HTMLSelectElement) => {
            if (element.localName === 'select') {
                element.innerHTML = ''
                const hidGetClientByProductGroup = document.getElementById('hidGetClientByProductGroup') as HTMLFormElement
                fetch(
                    `${hidGetClientByProductGroup.value.toString()
                    }?id=${encodeURIComponent(GroupID)
                    }&Archived=${encodeURIComponent(Archived)}`,
                    {
                        method: 'POST'
                    }
                )
                    .then((response) => response.json())
                    .then((result) => {
                        result.forEach((elem: any) => {
                            const opt = document.createElement('option')
                            opt.value = elem.Value
                            opt.innerHTML = elem.Text
                            if (GroupID === parseInt(elem.Value)) {
                                opt.selected = true
                            }
                            element.appendChild(opt)
                        })
                        ddlClientInitialise()
                    })
                    .catch((ex) => {
                        alert(`Failed to retrieve contacts.${ex}`)
                    })
            }
        })
    }
}
export const fButtonClick = () => {
    PopulateClients(2, false)
}
export const hButtonClick = () => {
    PopulateClients(1, false)
}
export const allButtonClick = () => {
    PopulateClients(999, false)
}
export const mButtonClick = () => {
    PopulateClients(4, false)
}
export const pButtonClick = () => {
    PopulateClients(6123, false)
}
export const aButtonClick = () => {
    PopulateClients(999, true)
}
export const vButtonClick = () => {
    const ddlClientID = document.querySelector('.ddlClientID') as HTMLFormElement
    ddlClientID.innerHTML = ''
    const hidGetClientVendors = document.getElementById('hidGetClientVendors') as HTMLFormElement
    fetch(
        hidGetClientVendors.value.toString(),
        {
            method: 'POST'
        }
    )
        .then((response) => response.json())
        .then((result) => {
            result.forEach((elem: any) => {
                const opt = document.createElement('option')
                opt.value = elem.Value
                opt.innerHTML = elem.Text
                ddlClientID.appendChild(opt)
            })
        })
        .catch((ex) => {
            alert(`Failed to retrieve contacts.${ex}`)
        })
}
export const lButtonClick = () => {
    const ddlClientID = document.querySelector('.ddlClientID') as HTMLFormElement
    ddlClientID.innerHTML = ''
    const hidGetClientLead = document.getElementById('hidGetClientLead') as HTMLFormElement
    fetch(
        hidGetClientLead.value.toString(),
        {
            method: 'POST'
        }
    )
        .then((response) => response.json())
        .then((result) => {
            result.forEach((elem: any) => {
                const opt = document.createElement('option')
                opt.value = elem.Value
                opt.innerHTML = elem.Text
                ddlClientID.appendChild(opt)
            })
        })
        .catch((ex) => {
            alert(`Failed to retrieve leads.${ex}`)
        })
}
export const clientSelectButtons = () => {
    const pbutton = document.querySelector('.pbutton') as HTMLFormElement
    if (pbutton != null) {
        pbutton.addEventListener('click', () => {
            pButtonClick()
        })
    }
    const fbutton = document.querySelector('.fbutton') as HTMLFormElement
    if (fbutton != null) {
        fbutton.addEventListener('click', () => {
            fButtonClick()
        })
    }
    const hbutton = document.querySelector('.hbutton') as HTMLFormElement
    if (hbutton != null) {
        hbutton.addEventListener('click', () => {
            hButtonClick()
        })
    }
    const allbutton = document.querySelector('.allbutton') as HTMLFormElement
    if (allbutton != null) {
        allbutton.addEventListener('click', () => {
            allButtonClick()
        })
    }
    const mbutton = document.querySelector('.mbutton') as HTMLFormElement
    if (mbutton != null) {
        mbutton.addEventListener('click', () => {
            mButtonClick()
        })
    }
    const abutton = document.querySelector('.abutton') as HTMLFormElement
    if (abutton != null) {
        abutton.addEventListener('click', () => {
            aButtonClick()
        })
    }
    const vbutton = document.querySelector('.vbutton') as HTMLFormElement
    if (vbutton != null) {
        vbutton.addEventListener('click', () => {
            vButtonClick()
        })
    }
    const lbutton = document.querySelector('.lbutton') as HTMLFormElement
    if (lbutton != null) {
        lbutton.addEventListener('click', () => {
            lButtonClick()
        })
    }
}
export const timeCheck = () => {
    const TimeCheckDiv = document.querySelector(
        '.TimeCheck'
    ) as HTMLFormElement
    const TimeCheck = new Modal(TimeCheckDiv, {
        backdrop: true,
        keyboard: true
    })
    const LogHours = document.querySelector('.LogHours') as HTMLInputElement
    if (LogHours != null) {
        LogHours.addEventListener('focusout', () => {
            if (LogHours.value.toString() >= '3') {
                TimeCheck.show()
            }
        })
    }
    const btnCancelTimeCheck = document.querySelectorAll('.btnCancelTimeCheck') as NodeListOf<HTMLButtonElement>
    if (btnCancelTimeCheck != null) {
        btnCancelTimeCheck.forEach((btn: HTMLButtonElement) => {
            btn.addEventListener('click', () => {
                TimeCheck.hide()
            })
        })
    }
}
export const modalMove = () => {
    const modal = document.querySelectorAll('.modal-dialog') as NodeListOf<HTMLDivElement>
    modal.forEach((element: HTMLDivElement) => {
        const header = element.firstElementChild!.firstElementChild
        if (header?.classList.toString() !== '') {
            new Draggabilly(element, {
                handle: header!.classList.toString()
            })
        }
    })
}
